var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.27076,10.81335a2.72389,2.72389,0,1,0,.00129,2.454l.00459-.00937A2.69194,2.69194,0,0,0,8.277,10.82619Zm.72018,3.428A3.84329,3.84329,0,1,1,8.991,9.842l5.516-2.75836a3.805,3.805,0,0,1-.1937-1.19865,3.85036,3.85036,0,1,1,.695,2.19953L9.49269,10.84269a3.80346,3.80346,0,0,1-.00025,2.39791l5.51592,2.75832a3.83813,3.83813,0,1,1-.50249,1.00028Zm9.16572-5.63253A2.73175,2.73175,0,1,0,15.72275,7.102,2.724,2.724,0,0,0,18.15666,8.60886ZM15.71627,16.994a2.797,2.797,0,1,0,.00606-.01174Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutline);
export default __webpack_public_path__ + "static/media/share_outline.5578c74800100f4ac2622b8dbf4977f2.svg";
export { ForwardRef as ReactComponent };